/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function FolderIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M4 10c0-2.187 1.75-4 4-4h8.25c1.188 0 2.313.5 3.188 1.375L22.063 10H32c2.188 0 4 1.813 4 4v16c0 2.25-1.812 4-4 4H8c-2.25 0-4-1.75-4-4zm4-1c-.562 0-1 .5-1 1v20c0 .563.438 1 1 1h24c.5 0 1-.437 1-1V14c0-.5-.5-1-1-1H21.875c-.625 0-1.312-.25-1.75-.687l-2.812-2.876C17 9.188 16.625 9 16.25 9z"/>}
        </IconWrapper>);
}
